import type { Theme } from '@mui/material'

export const getCSSVariables = (tokens: Theme['tokens']) => {
  return {
    '--font-family': `'${tokens.fontFamily}'`,
    '--secondary-font-family': `'${tokens.secondaryFontFamily}'`,
    '--content-font-family': `'${tokens.contentFontFamily}'`,
    '--root-bg': tokens.rootBg,
    '--layer-upper-bg': tokens.layerUpperBg,
    '--layer-upper-blur': tokens.layerUpperBlur,
    '--layer-upper-opacity': tokens.layerUpperOpacity,
    '--home-bg-overlay': tokens.homeBgOverlay,
    '--home-proceed-btn-color': tokens.homeProceedBtnColor ?? `${tokens.rootBg} !important`, // inherited
    '--primary-bg': tokens.primaryBg,
    '--primary-hi': tokens.primaryHi,
    '--secondary-bg': tokens.secondaryBg,
    '--triton-bg': tokens.tritonBg,
    '--primary-color': tokens.primaryColor,
    '--secondary-color': tokens.secondaryColor,
    '--accent-color': tokens.accentColor,
    '--info-channel-widget-bg': tokens.infoChannelWidgetBg,
    '--map-main-color': tokens.mapMainColor,
    '--btn-active-color': tokens.btnActiveColor,
    '--box-shadow': tokens.boxShadow,
    '--btn-main-color': tokens.btnMainColor,
    '--btn-bg-color': tokens.btnBgColor,
    '--btn-text-color': tokens.btnTextColor,
    '--btn-active-bg-color': tokens.btnActiveBgColor,
    '--btn-locker-bg': tokens.btnLockerBg,
    '--meter-color': tokens.meterColor,
    '--meter-font-color': tokens.meterFontColor,
    '--meter-heading-arc-rgb-color': tokens.meterHeadingArcRgbColor,
    '--meter-depth-gradient-colors': tokens.meterDepthGradientColors,
    '--menu-bg': tokens.menuBg,
    '--menu-color': tokens.menuColor,
    '--menu-active-color': tokens.menuActiveColor,
    '--menu-color-filter': tokens.menuColorFilter,
    '--menu-active-color-filter': tokens.menuActiveColorFilter,
    '--chart-primary-color': tokens.chartPrimaryColor,
    '--chart-secondary-color': tokens.primaryColor,
    '--chart-bar-linear-gradient-0-color': tokens.chartBarLinearGradient0Color,
    '--chart-bar-linear-gradient-0-opacity': tokens.chartBarLinearGradient0Opacity,
    '--chart-bar-linear-gradient-1-color': tokens.chartBarLinearGradient1Color,
    '--chart-bar-linear-gradient-1-opacity': tokens.chartBarLinearGradient1Opacity,
    '--chart-air-color': tokens.chartAirColor,
    '--chart-water-color': tokens.chartWaterColor,
    '--chart-line-color': tokens.chartLineColor,
    '--chart-tick-color': tokens.chartTickColor,
    '--gauge-wind1-color': tokens.gaugeWind1Color,
    '--gauge-wind2-color': tokens.gaugeWind2Color,
    '--menu-tab-color': tokens.menuTabColor,
    '--submenu-tab-color': tokens.submenuTabColor,
    '--scrollbar-thumb-color': tokens.scrollbarThumbColor,
    '--scrollbar-track-color': tokens.scrollbarTrackColor,
    '--calendar-event-header-color': tokens.calendarEventHeaderColor,
    '--calendar-primary-color': tokens.calendarPrimaryColor,
    '--calendar-secondary-color': tokens.calendarSecondaryColor,
    '--calendar-selected-range-color': tokens.calendarSelectedRangeColor,
    '--calendar-on-times-page-primary-color': tokens.calendarPrimaryColor,
    '--heading-gauge-radial-gradient-0-color': tokens.headingGaugeRadialGradient0Color,
    '--heading-gauge-radial-gradient-1-color': tokens.headingGaugeRadialGradient1Color,
    '--sea-temp-color': tokens.seaTempColor,
    '--mechanical-component-circle-gradient-0-color': tokens.mechanicalComponentCircleGradient0Color,
    '--mechanical-component-circle-gradient-1-color': tokens.mechanicalComponentCircleGradient1Color,
    '--logo-dark': tokens.logoDark,
    '--logo-light': tokens.logoLight,
    '--tooltip-bg-color': tokens.layerUpperBg, // inherited
    '--image-tooltip-bg-color': tokens.infoChannelWidgetBg, // inherited
    '--table-border-color': tokens.tableBorderColor,
    '--sat-antennas-rect': tokens.satAntennasRect,
    '--mechanical-component-primary-color': tokens.mechanicalComponentPrimaryColor,
    '--mechanical-component-secondary-color': tokens.mechanicalComponentSecondaryColor,
    '--mechanical-progress-bar': tokens.mechanicalProgressBar,
    '--map-nav-btn-bgc': tokens.mapNavBtnBgc ?? tokens.mapMainColor, // inherited
    '--svg-wire-circle-color': tokens.svgWireCircleColor,
    '--draw-fab-button-color': tokens.drawFabButtonColor
  }
}
